import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Copy, Download } from "lucide-react";
import { toast } from "sonner";

export default function QRBlock({ value, label, size = 168, testid = "qr" }) {
  const ref = useRef(null);
  const copy = () => { navigator.clipboard.writeText(value); toast.success("Link copied!"); };
  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url; a.download = `${label || "arena"}-qr.png`; a.click();
  };
  return (
    <div className="flex flex-col items-center gap-3" data-testid={`${testid}-block`}>
      <div ref={ref} className="bg-white p-3 rounded-2xl" data-testid={`${testid}-code`}>
        <QRCodeCanvas value={value} size={size} level="M" includeMargin={false} />
      </div>
      <div className="flex gap-2 w-full">
        <Button variant="secondary" size="sm" className="flex-1 rounded-full" onClick={copy} data-testid={`${testid}-copy`}>
          <Copy className="w-4 h-4 mr-1" /> Copy Link
        </Button>
        <Button variant="secondary" size="sm" className="flex-1 rounded-full" onClick={download} data-testid={`${testid}-download`}>
          <Download className="w-4 h-4 mr-1" /> Download
        </Button>
      </div>
    </div>
  );
}
